import * as Yup from 'yup';

export default Yup
  .string()
  .trim()
  .max(20, 'O IMEI não pode ter mais de 15 dígitos')
  .min(14, 'O IMEI deve conter pelo menos 14 dígitos');
